import uuidv4 from 'uuid/v4'

export default {
  getRandomString: uuidv4,
  pluralize: ({ string, count }) => `${string}${count === 1 ? '' : 's'}`,
  arrayBufferToString: (ab) =>
    new Uint8Array(ab).reduce((p, c) => p + String.fromCharCode(c), ''),
  formatPhoneNumber: (str) => {
    const cleaned = ('' + str).replace(/\D/g, '')
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)

    if (match) {
      const intlCode = match[1] ? '+1 ' : ''
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }

    return null
  },
  prettifyCamelCase: (str) => {
    let output = ''
    const len = str.length
    let char

    for (let i = 0; i < len; i++) {
      char = str.charAt(i)
      if (i === 0) {
        output += char.toUpperCase()
      } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
        output += ' ' + char
      } else if (char === '-' || char === '_') {
        output += ' '
      } else {
        output += char
      }
    }
    return output
  },
  capitalCase: (str) => {
    if (typeof str === 'string') {
      return str
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    }
    return str
  },
  removeDashes: (str) => {
    return str.toLowerCase().replace(/[-_]/gi, ' ')
  }
}
